import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { managedCompaniesSelector } from '../Settings/store/SettingsSelectors'
import CountriesAdmin, { ICountriesAdminProps, ICountriesAdminDispatchProps } from './CountriesAdmin'
import {
  getCompanyInfo,
  updateCompanyInfo,
  setCompanyAdminSelectedCompanyId,
} from '../CompanyAdmin/store/CompanyAdminActions'
import {
  getCompanyAdminInfo,
  getCompanyAdminLoading,
  getCompanyAdminSaving,
  getCompanyAdminLastUpdated,
  getCompanyAdminSelectedCompanyId,
} from '../CompanyAdmin/store/CompanyAdminSelectors'

const mapStateToProps = (state: IGlobalState): ICountriesAdminProps => ({
  managedCompanies: managedCompaniesSelector(state),
  companyInfo: getCompanyAdminInfo(state),
  loading: getCompanyAdminLoading(state),
  saving: getCompanyAdminSaving(state),
  lastUpdated: getCompanyAdminLastUpdated(state),
  selectedCompanyId: getCompanyAdminSelectedCompanyId(state),
})

const mapDispatchToProps: ICountriesAdminDispatchProps = {
  getCompanyInfo,
  updateCompanyInfo,
  setCompanyAdminSelectedCompanyId,
}

export default connect(mapStateToProps, mapDispatchToProps)(CountriesAdmin)
